import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';
//import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Spinner, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { FiAlertCircle, FiCalendar, FiClock } from 'react-icons/fi';
import Skeleton from 'react-loading-skeleton';


const TicketSinSolucion = () => {
    const { setToken, token } = useToken();
    const { showErrorToast } = useToast();
    const [tickets, setTickets] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [hasMore, setHasMore] = useState(true);
    const [page, setPage] = useState(1);
    const [totalTickets, setTotalTickets] = useState(0);
    const [mostrarComponente, setMostrarComponente] = useState(false);

    // Skeleton Loading
    const TicketSkeleton = () => (
        <Row className="g-2 p-2">
            {[1, 2, 3, 4, 5].map((i) => (
                <Col key={i} xs={12}>
                    <div style={{
                        padding: "12px",
                        border: "1px solid #e3e3e3",
                        borderRadius: "8px",
                        background: "transparent"
                    }}>
                        <Skeleton height={20} width="70%" className="mb-2" />
                        <Skeleton height={16} width="100%" className="mb-2" />
                        <Skeleton height={16} width="90%" className="mb-2" />
                    </div>
                </Col>
            ))}
        </Row>
    );

    // Obtiene los tickets sin solución
    const fetchMoreTickets = async (currentPage = page) => {
        try {
            const response = await fetch('/api/soportetecnico/GetTicketsSinSolucion', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                },
                body: JSON.stringify({
                    date: null,
                    idUsuario: 0,
                    pagina: currentPage,
                    tamanioPagina: 10
                })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    const parsed = JSON.parse(data.detalles);
                    
                    if (parsed.table3 && parsed.table3[0]) {
                        const total = parsed.table3[0].totalTickets;
                        setTotalTickets(total);
                        
                        // Mostrar componente solo si hay tickets
                        if (currentPage === 1) {
                            setMostrarComponente(total > 0);
                        }
                    }
                    
                    const nuevosTickets = parsed.table2;
                    if (nuevosTickets && nuevosTickets.length > 0) {
                        // Si es la primera página, reemplazar en lugar de agregar
                        if (currentPage === 1) {
                            setTickets(nuevosTickets);
                        } else {
                            setTickets(prev => [...prev, ...nuevosTickets]);
                        }
                        setPage(currentPage + 1);

                        if (nuevosTickets.length < 10) {
                            setHasMore(false);
                        }
                    } else {
                        setHasMore(false);
                    }
                } else {
                    showErrorToast(data.vMessage);
                    setHasMore(false);
                }
            } else {
                showErrorToast(response.status + ' ' + response.statusText);
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                setHasMore(false);
            }
        } catch (error) {
            showErrorToast('Error: ' + error.message);
            setHasMore(false);
        } finally {
            setCargando(false);
        }
    };

    useEffect(() => {
        // Cargar tickets al montar el componente
        setTickets([]);
        setPage(1);
        setHasMore(true);
        setCargando(true);
        fetchMoreTickets(1);
        
    }, []);

    // Función para determinar el color del badge según los días
    const getDiasBadgeColor = (dias) => {
        if (dias >= 7) return 'danger';
        if (dias >= 3) return 'warning';
        return 'info';
    };

    // No mostrar el componente si no hay tickets sin solución
    if (!mostrarComponente && !cargando) {
        return null;
    }

    return (
        <Card>
            <Card.Header className="bg-light border-bottom px-4 py-3">
                <div className="d-flex align-items-center">
                    <FiAlertCircle className="me-2 text-danger" size={20} />
                    <h5 className="mb-0 fw-bold text-800">Tickets Sin Solución</h5>
                    {tickets.length > 0 && (
                        <span className="badge bg-danger bg-opacity-10 text-danger ms-2 rounded-pill py-1 px-2 small">
                            {totalTickets}
                        </span>
                    )}
                </div>
            </Card.Header>
            <Card.Body className="p-2 overflow-x-hidden" id="scrollableTargetTicketsSinSolucion" style={{ maxHeight: '600px', overflow: 'auto' }}>
                {cargando ? (
                    <TicketSkeleton />
                ) : (
                    <InfiniteScroll
                        dataLength={tickets.length}
                        next={fetchMoreTickets}
                        hasMore={hasMore}
                        loader={
                            <div className="d-flex justify-content-center align-items-center py-3">
                                <Spinner animation="border" size="sm" variant="danger" className="me-2" />
                                <span className="text-muted" style={{ fontSize: '0.85rem' }}>Cargando más tickets...</span>
                            </div>
                        }
                        scrollableTarget="scrollableTargetTicketsSinSolucion"
                            scrollThreshold={0.95}
                            style={{ overflowX: 'hidden' }} // Agregar esto
                        endMessage={
                            tickets.length > 0 && (
                                <div className="text-center py-3 border-top mt-2">
                                    <small className="text-muted" style={{ fontSize: '0.8rem' }}>
                                        <FiAlertCircle className="me-1" size={12} />
                                        No hay más tickets pendientes
                                    </small>
                                </div>
                            )
                        }
                    >
                        {tickets.length === 0 ? (
                            <div className="text-center py-5">
                                <FiAlertCircle size={48} className="text-success mb-3" />
                                <h6 className="text-success mb-2">¡Excelente!</h6>
                                <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>
                                    No hay tickets pendientes de solución
                                </p>
                            </div>
                        ) : (
                            <Row className="g-2">
                                {tickets.map((ticket, index) => (
                                    <Col key={`${ticket.idTicketSoporte}-${index}`} xs={12}>
                                        <div style={{
                                            padding: "12px 16px",
                                            border: "1px solid #e3e3e3",
                                            borderRadius: "8px",
                                            background: "transparent",
                                            transition: "all 0.2s ease",
                                            cursor: "default",
                                            position: "relative"
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.borderColor = "#dc3545";
                                            e.currentTarget.style.boxShadow = "0 2px 8px rgba(220, 53, 69, 0.15)";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.borderColor = "#e3e3e3";
                                            e.currentTarget.style.boxShadow = "none";
                                        }}>
                                            {/* Badge de días sin resolver */}
                                            <Badge 
                                                bg={getDiasBadgeColor(ticket.diasSinResolver)}
                                                className="position-absolute"
                                                style={{ 
                                                    top: "12px",
                                                    right: "16px",
                                                    fontSize: "0.75rem",
                                                    padding: "4px 8px"
                                                }}
                                            >
                                                <FiClock size={11} className="me-1" />
                                                {ticket.diasSinResolver} {ticket.diasSinResolver === 1 ? 'día' : 'días'}
                                            </Badge>

                                            {/* Primera línea: Agente, Fecha y Cliente */}
                                            <div className="mb-2" style={{ paddingRight: "100px" }}>
                                                <div className="d-flex align-items-center mb-1">
                                                    <FiCalendar size={13} className="text-muted me-1" />
                                                    <span className="text-muted" style={{ fontSize: "0.75rem" }}>
                                                        {new Date(ticket.dCreatedDate).toLocaleDateString('es-MX', { 
                                                            day: '2-digit', 
                                                            month: 'short', 
                                                            year: 'numeric' 
                                                        }).replace('.', '')} {new Date(ticket.dCreatedDate).toLocaleTimeString('es-MX', { 
                                                            hour: '2-digit', 
                                                            minute: '2-digit', 
                                                            hour12: true 
                                                        })}
                                                    </span>
                                                </div>
                                                <div className="mb-1">
                                                    <strong className="text-700" style={{ fontSize: "0.8rem" }}>Registrado por: </strong>
                                                    <span className="text-800" style={{ fontSize: "0.85rem" }}>
                                                        {ticket.vNombre}
                                                    </span>
                                                </div>
                                                <div>
                                                    <strong className="text-700" style={{ fontSize: "0.8rem" }}>Cliente: </strong>
                                                    <Link 
                                                        to={`/clientes/detalle/${ticket.idClienteAkasia}`}
                                                        className="text-decoration-none fw-semibold"
                                                        style={{ fontSize: "0.85rem" }}
                                                    >
                                                        {ticket.vNombreCliente}
                                                    </Link>
                                                </div>
                                            </div>

                                            {/* Problema */}
                                            <div>
                                                <FiAlertCircle size={13} className="text-danger me-1" style={{ verticalAlign: "middle" }} />
                                                <span className="fw-bold text-700" style={{ fontSize: "0.8rem" }}>Problema: </span>
                                                <span className="text-dark" style={{ 
                                                    fontSize: "0.8rem",
                                                    whiteSpace: "pre-wrap",
                                                    wordBreak: "break-word"
                                                }}>
                                                    {ticket.vProblema}
                                                </span>
                                            </div>

                                            {/* IP */}
                                            {ticket.vIP && (
                                                <div className="mt-2">
                                                    <code style={{ 
                                                        fontSize: "0.7rem",
                                                        padding: "2px 6px",
                                                        background: "#f8f9fa",
                                                        borderRadius: "4px",
                                                        color: "#6c757d"
                                                    }}>
                                                        {ticket.vIP}
                                                    </code>
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        )}
                    </InfiniteScroll>
                )}
            </Card.Body>
            <Card.Footer>
                <div className="text-center text-muted">
                    {tickets.length} / {totalTickets} ticket{tickets.length !== 1 ? 's' : ''} cargado{tickets.length !== 1 ? 's' : ''}
                </div>
            </Card.Footer>
        </Card>
    );
};

TicketSinSolucion.propTypes = {
};

export default TicketSinSolucion;
